import { environment } from '../../../environments/environment';

let devLogLevels = !!environment.devLogLevels;

(window as any)._insightsLogging = {
  debug: !!environment.logLevels?.debug,
  info: !!environment.logLevels?.info,
  warn: !!environment.logLevels?.warn,
  error: !!environment.logLevels?.error,
  categories: {
    ...environment?.logLevels?.categories
  }
};

export function setLogCategoryActiveInStorage(category: string, value: boolean) {
  try {
    localStorage.setItem(`_insightsLogging.${category}`, JSON.stringify(value));
  }
  catch {
  }
}

function isLogCategoryActiveInStorage(category: string) {
  try {
    let value = JSON.parse(localStorage.getItem(`_insightsLogging.${category}`));
    return typeof value === 'boolean' ? value : true;
  }
  catch {
    return true;
  }
}

const isLogLevelActiveInEnv = (level: string) => {
  return environment.logLevels && (environment.logLevels as any)[level];
};

const isLogLevelActive = devLogLevels
  ? (level: string) => {
    return ((typeof (window as any)._insightsLogging === 'object')
        && ((window as any)._insightsLogging[level])) || isLogLevelActiveInEnv(level);
  }
  : isLogLevelActiveInEnv;

const isLogCategoryActive = devLogLevels
  ? (category: string) => {
    if (typeof (window as any)._insightsLogging === 'object') {
      let categories = (window as any)._insightsLogging.categories;

      if (typeof categories !== 'object') 
        categories = (window as any)._insightsLogging.categories = {};

      let key = category.toLowerCase();

      if (typeof categories[key] != 'boolean')
        categories[key] = isLogCategoryActiveInStorage(key);

      return !!categories[key];
    }
  }
  : (category: string) => false;

export function logger(category: string) {
  return {
    debug: makeLogFunction(category, 'debug', console.debug),
    info: makeLogFunction(category, 'info', console.info),
    warn: makeLogFunction(category, 'debug', console.warn),
    error: makeLogFunction(category, 'debug', console.error),
  };
}

function makeLogFunction(category: string, level: string, call: Function): ((message: any, ...args: any) => void) {
  if (devLogLevels) {
    return ((message: string, ...args: any[]) => {
      if (isLogLevelActive(level)) {
        if (isLogCategoryActive(category))
          call.apply(console, getCallArgs(category, message, args));
      }
    });
  }
  else {
    if (isLogLevelActiveInEnv(level)) {
      return ((message: string, ...args: any[]) => {
        if (isLogCategoryActive(category))
          call.apply(console, getCallArgs(category, message, args));
      });
    }
    else
      return () => { };
  }
}

function getCallArgs(category: string, message: any, args: any) {
  if (typeof message === 'string') {
    return [`[${category}] ${message}`, ...args];
  }
  else {
    return [`[${category}]`, message, ...args]
  }
}
